// removed by extract-text-webpack-plugin
module.exports = {"Container":"_z9l54","ContainerInner":"_f2Dbq","Para":"_2zV_S","ParaImage":"_1akxo","Inner":"_2ftLk","CustomDivider":"_3U3RU","HeadingMain":"_1C9Sv","Green":"_IrGjE","WhiteBackground":"_2byrg","Divider":"_ojN_8","CloseImage":"_2uApK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Hotel/HotelSummary/HotelSummary.scss
// module id = 659
// module chunks = 0